import React from 'react';

import { ImageGalleryBlockData } from 'api/cms';
import { AmpCardsBlock } from 'cms/blocks/Amp/AmpCardsBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpImageGalleryBlock({
  content,
  blockId,
  data,
}: AmpBlockMappingComponentProps<ImageGalleryBlockData>) {
  return (
    <AmpCardsBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        imageSize: 'LARGE',
        cards: data.images.map((image) => ({
          image,
        })),
        seeMoreText: getText('See All Images'),
      }}
    />
  );
}
